import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'hooks/useAuth';
import { Link } from 'react-router-dom';
import { Button, Form, Row, Col } from 'react-bootstrap';
import Divider from 'components/common/Divider';
import SocialAuthButtons from './SocialAuthButtons';

const RegistrationForm = ({ hasLabel }) => {
 const { handleFieldChange, handleSubmit, formData } = useAuth('signup', {
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
  isAccepted: false
 });

 return (
  <Form onSubmit={handleSubmit}>
   <Form.Group className="mb-3">
    {hasLabel && <Form.Label>Nombre</Form.Label>}
    <Form.Control
     placeholder={!hasLabel ? 'Nombre' : ''}
     value={formData.name}
     name="name"
     onChange={handleFieldChange}
     type="text"
    />
   </Form.Group>

   <Form.Group className="mb-3">
    {hasLabel && <Form.Label>Correo ELectrónico</Form.Label>}
    <Form.Control
     placeholder={!hasLabel ? 'Email' : ''}
     value={formData.email}
     name="email"
     onChange={handleFieldChange}
     type="text"
    />
   </Form.Group>

   <Row className="g-2 mb-3">
    <Form.Group as={Col} sm={6}>
     {hasLabel && <Form.Label>Contaseña</Form.Label>}
     <Form.Control
      placeholder={!hasLabel ? 'Contraseña' : ''}
      value={formData.password}
      name="password"
      onChange={handleFieldChange}
      type="password"
     />
    </Form.Group>
    <Form.Group as={Col} sm={6}>
     {hasLabel && <Form.Label>Confirme Contraseña</Form.Label>}
     <Form.Control
      placeholder={!hasLabel ? 'Confirma Contraseña' : ''}
      value={formData.confirmPassword}
      name="confirmPassword"
      onChange={handleFieldChange}
      type="password"
     />
    </Form.Group>
   </Row>

   <Form.Group className="mb-3">
    <Form.Check type="checkbox" id="acceptCheckbox" className="form-check">
     <Form.Check.Input type="checkbox" name="isAccepted" checked={formData.isAccepted} onChange={handleFieldChange} />
     <Form.Check.Label className="form-label">
      Acepto<Link to="#!"> términos</Link> y <Link to="#!">politica de pivacidad</Link>
     </Form.Check.Label>
    </Form.Check>
   </Form.Group>

   <Form.Group className="mb-4">
    <Button
     className="w-100"
     type="submit"
     disabled={!formData.name || !formData.email || !formData.password || !formData.confirmPassword || !formData.isAccepted}
    >
     Registrar
    </Button>
   </Form.Group>
   <Divider>Registrar con</Divider>

   <SocialAuthButtons />
  </Form>
 );
};

RegistrationForm.propTypes = {
 hasLabel: PropTypes.bool
};

export default RegistrationForm;
